/**
 * A note attached to a waterfall right (#10602): why this entitlement exists.
 *
 * Written by a user, or by AI Magic Import to keep the justification of what it built: the
 * contract clause it read, the page, and the rule it applied. AI notes are read-only in the UI
 * and flagged as such, so a user can never be blamed for wording the model chose.
 *
 * Declared outside libs/model/src/lib/waterfall/ on purpose: the frozen perimeter only receives
 * the optional `notes` field on `Right`, nothing executable.
 */
export interface RightNote {
  origin: 'user' | 'ai';
  text: string;
  createdAt: Date;
  /** Set when origin is 'user'. */
  authorId?: string;
  /** Set when origin is 'ai', e.g. "gemini-3.1-flash-lite". */
  model?: string;
}
